<template>
  <div class="special-wrapper">
    <SectionTitle :title="title" subtitle="特別企劃" />
    <div class="special">
      <div class="special__description">
        邀請作者們齊聚，<br />暢談企劃主題與小說構思的特別節目！
      </div>
      <div class="pecial__row row">
        <div class="row__main">
          <div class="row__main_title">Ep.01<span>*無劇透</span></div>
          <div class="row__main_desc">作者訪談與幕後花絮</div>
        </div>
        <Button
          content="EP.01 搶先聽"
          @click.native="handleClick('https://lihi1.cc/28yB6')"
        />
      </div>
      <div class="pecial__row row">
        <div class="row__main">
          <div class="row__main_title">Ep.02<span>*有劇透</span></div>
          <div class="row__main_desc">作者交互提問集</div>
        </div>
      </div>
      <div class="pecial__row row three">
        <div class="row__main">
          <div class="row__main_title">
            Ep.03 <br class="mobile" />BONUS TRACK
          </div>
          <div class="row__main_desc">心得感想與提問熱烈募集中！</div>
          <div class="row__main_detail">
            有心得想對作者告白？<br
              class="mobile"
            />聽了訪談產生更多疑問？<br />
            想聽更多幕後花絮？<br />
            收集足夠問題後，將召集作者們再錄一集來回應 ！<br />
            究竟BONUS TRACK將成為大感謝祭，<br
              class="mobile"
            />還是謝罪記者會！？<br />
            讓我們拭目以待！
          </div>
        </div>
        <div class="row__bottom">
          <div class="row__bottom_hint">*主辦方保留挑選問題的權利</div>
          <Button
            content="提問表單"
            @click.native="handleClick('https://forms.gle/LarHCEdzTd43Rxkf9')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "./SectionTitle.vue";
import Button from "./Button.vue";
export default {
  components: {
    SectionTitle,
    Button,
  },
  data() {
    return {
      title: ["SPECIAL", "EVENT."],
    };
  },
  methods: {
    handleClick(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);
.special-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  color: #000;
  @media (min-width: 768px) {
    align-items: flex-end;
  }
}
/deep/.title__subtitle {
  top: 110px;
  @media (min-width: 768px) {
    top: 144px;
  }
  @media (min-width: 1200px) {
    top: 194px;
  }
}

.special {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 34px;
  @media (min-width: 768px) {
    width: 800px;
  }

  &__description {
    font-weight: 100;
    font-size: 12px;
    line-height: 16px;
    text-align: end;
    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 24px;
    }
    @media (min-width: 1200px) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  .row {
    font-family: Noto Sans;
    font-style: normal;
    font-weight: 100;
    font-size: 36px;
    line-height: 49px;
    text-align: center;
    align-self: center;
    margin-top: 28px;
    @media (min-width: 768px) {
      width: 100%;
      align-items: center;
      align-self: flex-start;
      display: flex;
      font-size: 64px;
      line-height: 87px;
      margin-top: 48px;
      text-align: start;
    }
    @media (min-width: 1200px) {
      font-size: 72px;
      line-height: 98px;
    }

    span {
      display: block;
      margin-top: 10px;
      font-size: 12px;
      line-height: 16px;
      color: #fff;
      font-family: Noto Sans;
      font-weight: 100;
      @media (min-width: 768px) {
        display: inline;
        font-size: 18px;
        line-height: 24px;
        margin: 0 0 0 10px;
      }
      @media (min-width: 1200px) {
        font-size: 24px;
        line-height: 32px;
      }
    }

    &__main {
      margin-bottom: 10px;
      &_desc {
        font-family: Noto Sans;
        font-style: normal;
        font-weight: 100;
        margin-top: 10px;
        font-size: 18px;
        line-height: 24px;
        @media (min-width: 768px) {
          display: inline;
          font-size: 24px;
          line-height: 32px;
        }
        @media (min-width: 1200px) {
          margin-top: 40px;
          font-size: 36px;
          line-height: 49px;
        }
      }
    }

    .button {
      font-size: 18px;
      line-height: 25px;
      padding: 12px 68px;
      width: fit-content;
      height: fit-content;
      font-weight: bold;
      margin: 0 auto;
      @media (min-width: 768px) {
        font-size: 26px;
        line-height: 35px;
        padding: 12px 32px;
      }
      @media (min-width: 1200px) {
        font-size: 32px;
        line-height: 44px;
        padding: 20px 45px;
      }
    }
  }
}

.three {
  @media (min-width: 768px) {
    flex-direction: column;
    align-items: start !important;
  }
  .mobile {
    @media (min-width: 768px) {
      display: none;
    }
  }

  .row__main {
    &_desc {
      margin-top: 0px;
    }
    &_detail {
      font-size: 12px;
      line-height: 16px;
      margin-top: 20px;
      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 24px;
        margin-top: 54px;
      }
      @media (min-width: 1200px) {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  .row__bottom {
    width: 100%;
    margin-bottom: 36px;
    @media (min-width: 768px) {
      display: flex;
      justify-content: space-between;
    }

    &_hint {
      font-size: 16px;
      line-height: 24px;
      margin: 24px 0 30px 0;
      color: #fff;
      @media (min-width: 768px) {
        color: #000;
      }
      @media (min-width: 1200px) {
        margin-top: 36px;
      }
    }
    .button {
      @media (min-width: 768px) {
        align-self: flex-end;
        margin-right: 51px;
      }
    }
  }
}
</style>
